/*
 * @Author: dairf dairf@189.cn
 * @Date: 2025-12-08 08:48:05
 * @LastEditTime: 2025-12-25 16:10:55
 * @FilePath: \fs-sxzx-web\src\utils\SysConfigUtils.ts
 * @Description: 
 * 
 * Copyright (c) 2025 by 福水智联, All Rights Reserved. 
 */
import { APIConfig } from "@/config/common";

export function getSysConfig(initialState: any, host: string) {
    const configList = initialState.sysConfigList?.data || 0;
    const result = {
        logoImageUrl: '/login/images/logo.png',
        logoImageUrl2: '/favicon.png',
        backgroundImageUrl: '/login/images/bg.jpg',
        title: "松溪数智政协",
        host: ""

    };
    // console.log('host', host);

    if (configList.length > 0) {
        const temp = configList.filter((item: any) => item.host === host)[0];


        if (temp) {
            result.logoImageUrl = APIConfig.FileUrl + "/" + temp.logoImageUrl?.[0]?.wjlj;
            result.logoImageUrl2 = APIConfig.FileUrl + "/" + temp.logoImageUrl2?.[0]?.wjlj;
            result.backgroundImageUrl = APIConfig.FileUrl + "/" + temp.backgroundImageUrl?.[0]?.wjlj;
            result.title = temp.title;
            result.host = temp.host;
        }
    }

    return result;

}